import Icon from 'veui/components/Icon'
import { IconChevronDoubleLeft } from 'dls-icons-vue'

Icon.register('chevron-double-left', IconChevronDoubleLeft)
